import _toConsumableArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import csvDataReducer, { isCsvDataModifyAction } from './csvDataReducer';

function reducer(state, action) {
  switch (action.type) {
    case 'reset':
      return _objectSpread({
        isLoading: true,
        undoStates: [],
        redoStates: [],
        csvData: {}
      }, action.payload);

    case 'content_fetched':
      return _objectSpread({}, state, {
        isLoading: false,
        serverContent: action.payload
      });

    case 'undo':
      if (state.undoStates.length === 0) throw new Error('Undo states is empty.');
      return _objectSpread({}, restoreStateFromUndoRedoState(state, state.undoStates[state.undoStates.length - 1]), {
        redoStates: [].concat(_toConsumableArray(state.redoStates), [getUndoRedoState(state)]),
        undoStates: state.undoStates.slice(0, state.undoStates.length - 1)
      });

    case 'redo':
      if (state.redoStates.length === 0) throw new Error('Redo states is empty.');
      return _objectSpread({}, restoreStateFromUndoRedoState(state, state.redoStates[state.redoStates.length - 1]), {
        undoStates: [].concat(_toConsumableArray(state.undoStates), [getUndoRedoState(state)]),
        redoStates: state.redoStates.slice(0, state.redoStates.length - 1)
      });

    case 'document_saved':
      return _objectSpread({}, state, {
        isSaving: false,
        csvData: csvDataReducer(state.csvData, action),
        // on save all undo/redo changes of csv are lost
        // remove any state related to csv data edits
        redoStates: getContentChangesStates(state, state.redoStates),
        // remove any state related to csv data edits
        undoStates: getContentChangesStates(state, state.undoStates)
      });

    case 'document_saving':
      return _objectSpread({}, state, {
        isSaving: true
      });

    case 'error':
      return _objectSpread({}, state, {
        isLoading: false,
        error: action.payload
      });

    default:
      {
        var newState = _objectSpread({}, state, {
          csvData: csvDataReducer(state.csvData, action)
        });

        if (state.content !== newState.content || isCsvDataModifyAction(action.type)) {
          newState.undoStates.push(getUndoRedoState(state));
          newState.redoStates = [];
        }

        return newState;
      }
  }
}

var getContentChangesStates = function getContentChangesStates(state, undoRedoStates) {
  var previousContent = null;
  var contentStates = [];
  undoRedoStates.forEach(function (undoRedoState) {
    if (undoRedoState.content !== previousContent) {
      contentStates.push({
        content: undoRedoState.content
      });
      previousContent = undoRedoState.content;
    }
  }); // the last element can be equal with current state

  if (contentStates.length > 0 && contentStates[contentStates.length - 1].content === state.content) contentStates.splice(contentStates.length - 1, 1);
  return contentStates;
};

var getUndoRedoState = function getUndoRedoState(state) {
  var csvDataEdits = {};

  for (var filePath in state.csvData) {
    if (state.csvData[filePath]) {
      csvDataEdits[filePath] = {
        edits: state.csvData[filePath].edits
      };
    }
  }

  return {
    csvDataEdits: csvDataEdits
  };
};

var restoreStateFromUndoRedoState = function restoreStateFromUndoRedoState(state, undoRedoState) {
  var result = _objectSpread({}, state, {
    csvData: undoRedoState.csvDataEdits === undefined ? state.csvData : Object.keys(state.csvData).reduce(function (acc, key) {
      acc[key] = _objectSpread({}, state.csvData[key]);
      if (undoRedoState.csvDataEdits[key]) acc[key].edits = undoRedoState.csvDataEdits[key].edits;
      return acc;
    }, {})
  });

  return result;
};

export default reducer;